import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { ErrorCode } from '../../modules/order-details';

/**
 * GetExcelConfig Input Action
 */
export class GetExcelConfigInput implements Msdyn365.IActionInput {
    public userToken: string;
    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
    }

    public getCacheKey = () => `GetExcelExportConfiguration-${this.userToken}`;
    public getCacheObjectType = () => 'GetExcelExportConfiguration';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetExcelConfigData {
    '@odata.context'?: string;
    value: [];
    error?: ErrorCode;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetExcelConfigInput(args);
};

async function action(_: GetExcelConfigInput, ctx: Msdyn365.IActionContext): Promise<IGetExcelConfigData> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetExcelConfigData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetExcelConfig`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { value: response.data.value, error: { errorCode: response.status, errorText: response.statusText } };
    }
    return { ...({} as IGetExcelConfigData), error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetExcelConfigData>>action,
    id: 'GetExcelConfig',
    input: createInput
});
